import { Shadow, Skeleton, VStack, HStack } from '@genial/components';
import { Spacing, BoxRadius, Color } from '@genial/design-tokens';
import { Box } from 'native-base';

export const CardLoading = () => {
  return (
    <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
      <Shadow testId="shadow" level={1} borderRadius="8px">
        <VStack w="full">
          <HStack
            w="full"
            py={Spacing['inline.xxxs']}
            px={Spacing['inline.xxs']}
            justifyContent="space-between"
            alignItems="center">
            <HStack flex={1 / 3} space={Spacing['inline.nano']}>
              <Skeleton
                height="20px"
                width="20px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="48px"
                width="54px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </HStack>
            <VStack flex={1 / 3} space={Spacing['inline.nano']}>
              <Skeleton
                height="15px"
                width="30px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="15px"
                width="100px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <VStack flex={1 / 3} space={Spacing['inline.nano']}>
              <Skeleton
                height="15px"
                width="30px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="15px"
                width="100px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
          </HStack>
          <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
          <HStack
            w="full"
            py={Spacing['inline.xxxs']}
            px={Spacing['inline.xxs']}
            justifyContent="space-between"
            alignItems="center">
            <VStack flex={1 / 3} space={Spacing['inline.nano']}>
              <Skeleton
                height="15px"
                width="30px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="15px"
                width="100px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <VStack flex={1 / 3} space={Spacing['inline.nano']}>
              <Skeleton
                height="15px"
                width="30px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="15px"
                width="100px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <VStack flex={1 / 3} space={Spacing['inline.nano']}>
              <Skeleton
                height="15px"
                width="100px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
          </HStack>
        </VStack>
      </Shadow>
    </VStack>
  );
};
